import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../app-services';

export const isAdminOrSuperAdminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isSuperAdmin() || authService.isAdmin() || router.createUrlTree(['/']);
};
